import { type ReactNode } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { TierDraft } from '../utils/group-tier-helpers';
import { DragHandle, RemoveButton } from './pricing-tier-actions';
import { GroupTierInputs } from './group-tier-inputs';

type Props = {
  id: string;
  tier: TierDraft;
  isFirst: boolean;
  isLast: boolean;
  canRemove: boolean;
  rangeError: boolean;
  amountError: boolean;
  onChange: (t: TierDraft) => void;
  onRemove: () => void;
};

function useTierSortable(id: string, locked: boolean) {
  const s = useSortable({
    id,
    animateLayoutChanges: () => false,
    disabled: locked,
  });
  const style = locked
    ? undefined
    : {
        transform: CSS.Transform.toString(s.transform),
        transition: s.transition,
      };
  return { ...s, style };
}

export function GroupTierRow(p: Props): ReactNode {
  const locked = p.isFirst || p.isLast;
  const { attributes, listeners, setNodeRef, style, isDragging } =
    useTierSortable(p.id, locked);
  const cls = `flex w-fit items-center gap-sm rounded-md px-1 py-1 ${isDragging ? 'opacity-30' : ''}`;
  return (
    <div ref={setNodeRef} style={style} className={cls}>
      <DragHandle
        locked={locked}
        listeners={listeners}
        attributes={attributes}
      />
      <GroupTierInputs {...p} />
      <RemoveButton canRemove={p.canRemove} onRemove={p.onRemove} />
    </div>
  );
}
